export default function InstanceFactory(){

    const getInstance = async (id:string,name:string,url:string,frameLoadHandler:Function) =>{

        if (window.electronAPI) {
            const preloadPath =  await window.electronAPI?.getPreloadPath();
            const webviewEl = document.createElement('webview') as any;
            webviewEl.setAttribute('class', 'appFrame');
            webviewEl.setAttribute('data-testid', id);
            webviewEl.setAttribute('id', id);
            webviewEl.setAttribute('title', name);
            webviewEl.setAttribute('src', url);
            webviewEl.setAttribute('partition',"persist:oktaSession");
            webviewEl.setAttribute('allowpopups','');
            webviewEl.setAttribute('preload', `file://${preloadPath}`);
            webviewEl.addEventListener('dom-ready', () => {
                webviewEl.openDevTools();
            });

            webviewEl.addEventListener('ipc-message', (event:any) => {
                if (event.channel === 'activity-change') {
                    const data = event.args[0];
                    console.log(`User is ${data.state} since ${new Date(data.timestamp)}`);
                    if (data.state === 'idle') {
                    console.log(`User is idle since ${new Date(data.timestamp)}`);
                    }
                }
            });
                
            return webviewEl;
        }else{
            const frameEl = document.createElement('iframe');
            frameEl.setAttribute('width', '100%');
            frameEl.setAttribute('height', '100%');
            frameEl.setAttribute('style', 'border: none;');
            frameEl.setAttribute('data-testid', id);
            frameEl.setAttribute('id', id);
            frameEl.setAttribute('allow', "camera;microphone;clipboard-read;clipboard-write;local-network-access *;");
            frameEl.setAttribute('title', name);
            frameEl.setAttribute('src',  url);
            frameEl.onload = () => frameLoadHandler();
            return frameEl;
        }
    }

    return {getInstance}
}